import { useState, useEffect, useRef } from "react";
import Searchbar from "../controls/Searchbar";
import { useDispatch, useSelector } from "react-redux";
import { setStore } from "../../redux/slices/storeSlice";
import { useNavigate } from "react-router-dom";
import { setAcl } from "../../redux/slices/aclSlice";
import AxiosAPI from "../../api/AxiosAPI";
import { toast } from "react-toastify";
import axios from "axios";
import { setPrintConfig } from "../../redux/slices/printConfigSlice";
import { fetchPrintConfig } from "../../api/printConfigApi";
import { isMobileView, saveFcmTokenData, saveLoginRecordData } from "../controls/CommonFunctions";
import { fetchAcl } from "../../api/UserApi";
import SignInLoading from "../controls/SignInLoading";
import { generateFcmToken } from "../../../fcmService";


const StoreSelect = () => {
  const [loading, setLoading] = useState(false);
  const store = useSelector((state) => state.store.storesList);
  const token = useSelector((state) => state.user.token);
  const user = useSelector((state) => state.user.user);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const [storeData, setStoreData] = useState(store || []);
  const [searchStoreData, setSearchStoredata] = useState(storeData);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [lastInputMethod, setLastInputMethod] = useState(null);
  const navigate = useNavigate();
  const storeListRef = useRef(null);
  const [aclLoading, setAclLoading] = useState(false);



  const handleInputChange = (newValue) => {
    setSearchQuery(newValue);
    setFocusedIndex(-1);
    setLastInputMethod(null);
  };
   const fetchPrintConfigData = async (storeID) => {
  try {
    const response = await fetchPrintConfig(storeID);
    if (response?.code == "0") {
      const filterData = response.printConfigs.filter((printConfig) => !printConfig?.IsDeleted);
      return filterData; // This returns the actual data
    }
    return []; // Return empty array if no data
  } catch (error) {
    console.log("error", error);
    toast.error("Runtime error occurred!");
    return []; // Return empty array on error
  }
}

  const handleClickStore = async (store) => {
    try {
      setAclLoading(true);

      // const response = await AxiosAPI.get(`/user/access?storeid=${store?.key}`);
      const response=await fetchAcl(store?.key);
    //  const response = await axios.get(`https://posibleapi-uat-789032243296.asia-south1.run.app/v2/user/access?storeid=${store?.key}`,
    //  //const response = await axios.get(`http://localhost:4000/v2/user/access?storeid=${store?.key}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`, // Add token in Authorization header
    //         "Content-Type": "application/json",
    //         // version: "1.1.22",
    //          version:userdata?.EnablePosBillingForPincode
    //         ? "1.1.28"
    //           : "1.1.22"
    //       },
    //     }
    //   );
      if (response.code == "0") {
        const aclModules = response.modules;
        dispatch(setAcl(aclModules));
      
        dispatch(setStore(store));
         await saveLoginRecordData(store,user);
         await saveFcmTokenData(store,user);
            const printConfigs = await fetchPrintConfigData(store.key);
            dispatch(setPrintConfig(printConfigs));
        console.log("store",store);
        navigate("/home");
      } else {
        toast.error("Failed to fetch acl");
      }
    } catch (error) {
      console.error("error",error);
      toast.error("Failed to fetch acl");
    } finally {
      setAclLoading(false);
    }
  };


  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSearchStoredata(storeData);
    } else {
 setSearchStoredata(
  storeData.filter((store) => {
    const query = searchQuery.toLowerCase();
    const storeName = store?.StoreName?.toLowerCase() || '';
    const storeCode = store?.StoreCode?.toLowerCase() || '';
    
    return storeName.includes(query) || storeCode.includes(query);
  })
);
    }
  }, [searchQuery, storeData]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (searchStoreData.length === 0) return;

      switch (e.key) {
        case "ArrowDown":
        case "ArrowUp":
        case "Enter":
          setLastInputMethod('keyboard');
          break;
        default:
          return;
      }

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setFocusedIndex((prev) => {
            const newIndex = prev < searchStoreData.length - 1 ? prev + 1 : prev;
            scrollIntoView(newIndex);
            return newIndex;
          });
          break;
        case "ArrowUp":
          e.preventDefault();
          setFocusedIndex((prev) => {
            const newIndex = prev > 0 ? prev - 1 : prev === -1 ? searchStoreData.length - 1 : -1;
            scrollIntoView(newIndex);
            return newIndex;
          });
          break;
        case "Enter":
          e.preventDefault();
          if (focusedIndex >= 0 && focusedIndex < searchStoreData.length) {
            handleClickStore(searchStoreData[focusedIndex]);
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [searchStoreData, focusedIndex]);

  const handleMouseEnter = (index) => {
    setLastInputMethod('mouse');
    setFocusedIndex(index);
  };

  const scrollIntoView = (index) => {
    if (storeListRef.current && index >= 0 && index < searchStoreData.length) {
      const items = storeListRef.current.querySelectorAll('div[role="button"]');
      if (items[index]) {
        items[index].scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      }
    }
  };

  const shouldShowHover = (index) => {
    if (!lastInputMethod) return true;
    if (lastInputMethod === 'mouse') return true;
    return focusedIndex === index;
  };

  return (
    <>
      {aclLoading ? <SignInLoading /> :
        <div className={`fixed z-50 inset-0 flex justify-center items-center  ${isMobileView() ? "h-full":"h-screen"} w-full login-purple-diagonal-gradient animate-gradient-x`}>
          {!isMobileView() && <>
            <div className="absolute w-[300px] h-[300px] rounded-full bg-white/10 top-[10%] left-[10%] animate-[float_8s_infinite_ease-in-out] z-50"></div>
            <div className="absolute w-[200px] h-[200px] rounded-full bg-white/10 bottom-[20%] right-[15%] animate-[float_8s_infinite_ease-in-out] z-50 animation-delay-[2s]"></div>
            <div className="absolute w-[150px] h-[150px] rounded-full bg-white/10 bottom-[10%] left-[20%] animate-[float_8s_infinite_ease-in-out] z-50 animation-delay-[4s]"></div>
          </>}

          <div className={`${isMobileView() ? "mx-5 h-[60%]" :"h-[80vh] "} relative backdrop-blur-sm bg-white w-full max-w-md rounded-2xl   custom-scrollable overflow-hidden shadow-2xl border border-white/20`}>
            {/* Decorative elements */}
            <div className="absolute top-0 left-0 w-32 h-32  rounded-full -translate-x-1/2 -translate-y-1/2 blur-xl"></div>


            {/* Header */}
            <div className="relative bg-[#FFFFFFD9] px-5 py-6 border-gray-200/50 flex items-center justify-between">
              <h1 className="text-2xl font-semibold text-gray-700 flex items-center">
                Store Selection
              </h1>
            </div>

            {/* Search area */}
            <div className="px-5 bg-[#FFFFFFD9] sticky top-0 z-10 pb-2">
              <Searchbar
                value={searchQuery}
                onChange={handleInputChange}
                placeholder="Search for store..."
                hideRefresh={true}
                hideFilter={true}
                className="shadow-lg"
              />
            </div>

            {/* Store list */}
            <div className="px-3 pb-4 overflow-y-auto">
              {loading ? (
                <div className="flex justify-center items-center h-40">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
                </div>
              ) : searchStoreData.length === 0 ? (
                <div className="text-center py-10 text-gray-500">
                  <div className="text-5xl mb-4">🔍</div>
                  <p>No stores found matching your search</p>
                </div>
              ) : (
                <div className="pb-4 overflow-y-auto max-h-[400px] custom-scrollable">
                  {searchStoreData.map((store, index) => (
                 <div
  key={index}
  role="button"
  tabIndex={0}
  onClick={() => handleClickStore(store)}
  onMouseEnter={() => handleMouseEnter(index)}
  className={`group rounded-xl px-5 w-full py-4 cursor-pointer font-normal
    border transition-all duration-300 flex items-center
    ${focusedIndex === index
      ? 'login-bg-primary-gradient text-white border-gray-300'
      : `border-transparent ${
          shouldShowHover(index)
            ? 'login-bg-primary-gradient-hover hover:text-white hover:border-gray-300'
            : 'text-gray-700'
        }`
    }`}
>
  {/* ICON */}
  <div
    className={`flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center mr-3
      transition-all duration-300
      ${focusedIndex === index
        ? 'login-bg-icon-active text-indigo-700'
        : `login-bg-icon-gradient text-indigo-600 ${
            shouldShowHover(index) ? 'group-hover:text-white' : ''
          }`
      }`}
  >
    {store?.StoreCode}
  </div>

  {/* TEXT */}
  <div>
    <div className="capitalize font-medium">{store.StoreName}</div>
    <div className="text-sm">{store?.Address1} {store?.Address2}</div>
    <div className="text-sm">{store?.City} {store?.State}</div>
    <div className="text-sm">{store?.Country}</div>
  </div>
</div>

                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
};

// Add these custom styles to your CSS
const CustomStyle = () => {
  return (
    <style>{`
      .animate-gradient-x {
        background-size: 200% 200%;
        animation: gradientBackground 15s ease infinite;
      }
      
      @keyframes gradientBackground {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
      
      @keyframes float {
        0% { transform: translateY(0px) rotate(0deg); }
        50% { transform: translateY(-20px) rotate(5deg); }
        100% { transform: translateY(0px) rotate(0deg); }
      }
      
      @keyframes progress {
        0% { width: 0%; }
        50% { width: 70%; }
        100% { width: 100%; }
      }
      
      .animate-progress {
        animation: progress 3s ease-in-out infinite;
      }
      
      .animation-delay-2000 {
        animation-delay: 2s;
      }
      .animation-delay-4000 {
        animation-delay: 4s;
      }
      
      .custom-scrollable::-webkit-scrollbar {
        width: 8px;
      }
      
      .custom-scrollable::-webkit-scrollbar-track {
        background: transparent;
      }
      
      .custom-scrollable::-webkit-scrollbar-thumb {
        background-color: rgba(156, 163, 175, 0.3);
        border-radius: 20px;
      }
      
      .custom-scrollable::-webkit-scrollbar-thumb:hover {
        background-color: rgba(156, 163, 175, 0.5);
      }
    `}</style>
  );
};

export default function StoreSelectWithStyles() {
  return (
    <>
      <CustomStyle />
      <StoreSelect />
    </>
  );
}
